const styles = theme =>({
    mainContainer:{
        minHeight:'92vh', padding:'1rem 1.5rem',display:'flex',justifyContent:'center',alignItems:'center', flexDirection:'column'
    },
    loader:{
        color:theme.orange
    },
})

export default styles